/* istanbul ignore file */
import {
    getAddressComponentFromLatLong,
    nullLocation
  } from './utils';
  import { logError } from '../utils';
  import { putInStorage } from './location-from-storage';
  
  export default () => new Promise(resolve => {
    navigator.geolocation.getCurrentPosition(
      async position => {
        const locationObj = position.coords;
        const { latitude = '', longitude = '' } = locationObj
        console.log('i am dom!!!', locationObj);
        try {
          const address = await getAddressComponentFromLatLong(latitude, longitude);
          putInStorage(address);
          resolve(address);
        } catch (e) {
          resolve({ latitude, longitude });
        }
      },
      err => {
        logError(err);
        resolve(nullLocation);
      }
    );
  });